import React, { useState, useEffect } from "react";

import { getScenarios } from "../../../services/api";

export default function Senario(props) {
  const [items, setItems] = useState([]);
  const [Seleted, setSeleted] = useState([]);

  useEffect(() => {
    ScenarioList();
  }, []);

  const ScenarioList = async () => {
    const res = await getScenarios();
    if (res.status === 200) {
      const option = res.data.map((item) => ({
        name: item.scenario_name,
        file: item.file_name,
      }));
      setItems(option);
    }
  };

  const handleSelect = (item) => {
    if (Seleted.includes(item)) {
      setSeleted(Seleted.filter((i) => i !== item));
      props.onSelect(Seleted.filter((i) => i !== item));
    } else {
      setSeleted([...Seleted, item]);
      props.onSelect([...Seleted, item]);
    }
  };

  return (
    <div className="flex justify-center items-center flex-col">
      <h1 className="pb-3 text-2xl font-bold">Choose scenarios !!</h1>
      <div className="grid grid-cols-4 gap-8">
        {items.map((item, index) => (
          <div
            key={index}
            className={`w-24 h-16 rounded-2xl shadow-lg flex items-center justify-center cursor-pointer transform transition-transform hover:scale-125 hover:rotate-6 text-white font-bold ${
              Seleted.includes(item)
                ? `bg-gain scale-125 rotate-0`
                : `bg-primary`
            }`}
            onClick={() => {
              handleSelect(item);
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
}
